import { Button, ButtonProps, message, Popconfirm } from "antd";
import { useStartGroupReconciliationMutation } from "redux/api/reconciliationsApiSlice";
import { PlayCircleOutlined } from "@ant-design/icons/lib/icons";

export const StartGroupReconcilationButton = ({ uuid, onStartSuccessful, ...buttonProps }: {
  uuid: string,
  onStartSuccessful?: () => void
} & ButtonProps) => {
  const [reconcile, { isLoading }] = useStartGroupReconciliationMutation();

  return (
    <Popconfirm
      title={"Sei sicuro di voler riconciliare questo broker?"}
      placement={"left"}
      disabled={buttonProps.disabled}
      okText={"Riconcilia"}
      onConfirm={() => {
        reconcile(uuid).unwrap()
          .then((result) => {
            onStartSuccessful?.();
            message.success("Riconciliazione iniziata");
          })
          .catch((err) => {
            message.error("Riconciliazione fallita");
          });
      }}>
      <Button
        title={"Riconcilia broker"}
        type={"text"}
        icon={<PlayCircleOutlined />}
        loading={isLoading}
        disabled={isLoading}
        {...buttonProps} />
    </Popconfirm>
  );
};